import React from 'react';
import { Typography, Button } from 'antd';
import { CreditAccountDriverIcon } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';
import useAmplitude from 'utils/hooks/useAmplitude';
import { CREDIT_ACCOUNT_FAQ_LINK } from 'constants/creditAccount.js';
import { AMPLITUDE_EVENT_TYPES, AMPLITUDE_EVENT_SOURCES } from 'constants/amplitude';
import { isOnOrAfterWalletGoLive } from 'utils/walletUtil';

import styles from './style.module.scss';

const { Title, Text } = Typography;

const CreditAccountOnboarding = ({ isRejectedStatus, setIsRedirectModalVisible }) => {
  const { translateText } = useTranslation();
  const { sendAmplitudeEvent } = useAmplitude();
  // No new Allstar account can be set up from the wallet go-live on
  const isSetUpAvailable = !isRejectedStatus && !isOnOrAfterWalletGoLive();

  const handleSetup = () => {
    setIsRedirectModalVisible(true);
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.creditAccountsSetUpButtonClicked, {
      source: AMPLITUDE_EVENT_SOURCES.creditAccountPage,
    });
    window.plausible?.('set up credit account clicked');
  };

  const handleFaqLinkClick = () => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.creditAccountsFaqClicked, {
      source: AMPLITUDE_EVENT_SOURCES.creditAccountPage,
    });
  };

  return (
    <>
      <section className={styles.topSection}>
        <span className={styles.titlesAndButton}>
          <Title className={styles.title}>
            {translateText('corporateAccounts.creditAccount.title')}
          </Title>
          <Title className={styles.subtitle}>
            {translateText('corporateAccounts.creditAccount.subtitle')}
          </Title>
          {isSetUpAvailable && (
            <Button type="primary" className={styles.setUpButton} onClick={handleSetup}>
              {translateText('corporateAccounts.creditAccount.setUpButton')}
            </Button>
          )}
        </span>
        <img
          src="/resources/images/credit_account_preview.png"
          alt="Credit account preview"
          className={styles.previewImage}
        />
      </section>

      <section className={styles.bottomSection}>
        <span className={styles.stepCards}>
          <span className={styles.stepCard}>
            <Text className={styles.stepCardTitle}>
              {translateText('corporateAccounts.creditAccount.stepCard1.title')}
            </Text>
            <Text className={styles.stepCardSubtitle}>
              {translateText('corporateAccounts.creditAccount.stepCard1.subtitle')}
            </Text>
          </span>
          <span className={styles.stepCard}>
            <Text className={styles.stepCardTitle}>
              {translateText('corporateAccounts.creditAccount.stepCard2.title')}
            </Text>
            <Text className={styles.stepCardSubtitle}>
              {translateText('corporateAccounts.creditAccount.stepCard2.subtitle')}
            </Text>
          </span>
          <span className={styles.stepCard}>
            <Text className={styles.stepCardTitle}>
              {translateText('corporateAccounts.creditAccount.stepCard3.title')}
            </Text>
            <Text className={styles.stepCardSubtitle}>
              {translateText('corporateAccounts.creditAccount.stepCard3.subtitle')}
            </Text>
          </span>
        </span>
        <span>
          <span className={styles.driversBlurb}>
            <CreditAccountDriverIcon />
            <Text className={styles.driversBlurbText}>
              {translateText('corporateAccounts.creditAccount.authorizedDriversBlurb')}
            </Text>
          </span>
          <span className={styles.faqLink}>
            <a
              href={CREDIT_ACCOUNT_FAQ_LINK}
              target="_blank"
              rel="noreferrer"
              onClick={handleFaqLinkClick}
            >
              {translateText('corporateAccounts.creditAccount.seeFaq')}
            </a>
          </span>
        </span>
      </section>
    </>
  );
};

export default CreditAccountOnboarding;
